import discipline from './discipline'
import holy from './holy'
import shadow from './shadow'

const priest = { specs: [discipline, holy, shadow] }

export default priest
